var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitOutputData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.5L36.5 24.5L30.5 18.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.5H36.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 35.3954V13.6046C18.5 12.9945 18.0055 12.5 17.3954 12.5H13.6046C12.9945 12.5 12.5 12.9945 12.5 13.6046L12.5 35.3954C12.5 36.0055 12.9945 36.5 13.6046 36.5H17.3954C18.0055 36.5 18.5 36.0055 18.5 35.3954Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 38.0818V10.9182C42.5 8.47811 40.5219 6.5 38.0818 6.5L10.9182 6.5C8.47811 6.5 6.5 8.47811 6.5 10.9182V38.0818C6.5 40.5219 8.47811 42.5 10.9182 42.5H38.0818C40.5219 42.5 42.5 40.5219 42.5 38.0818Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitOutputData);
export default __webpack_public_path__ + "static/media/submitOutputData.7efe04268aeeb178adbd966792914127.svg";
export { ForwardRef as ReactComponent };